import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { formaPago } from './formaPago';

@Injectable({
  providedIn: 'root'
})
export class FormaPagoService {



  constructor(private http: HttpClient) { }

 
  getformaPago(idEmisor: string) {  
    
    return this.http.get<formaPago[]>(environment.apiUrl+"/listarFormaPago/?id=" + idEmisor);  
  }  

  getUnidad(idUnidad: string) {  
    
    return this.http.get<formaPago[]>(environment.apiUrl+"/listarUnidad/?id=" + idUnidad);  
  }  

  getformaPagoCompra(idEmisor: string) {  
    
    return this.http.get<formaPago[]>(environment.apiUrl+"/listarUnidadCompra/?id=" + idEmisor);  
  }  

  getformaPagoVenta(idEmisor: string) {  
    
    return this.http.get<formaPago[]>(environment.apiUrl+"/listarUnidadVenta/?id=" + idEmisor);  
  }  

  

  setActulizar(formaPago: formaPago[]){
    console.log(formaPago);
    return this.http.put<string>(environment.apiUrl+"/actulizarFormaPago",formaPago)
  }

  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarFormaPago/?id="+id);
  }
  
}
